<template>
  <div class="menu-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <div class="col-sm-10 col-form-label uppercase">
                <strong>
                  <h3>
                    <router-link :to="{ name: 'menu_group_list'}" class="float-left mr-1 main-link">{{$t('menu_group.menu_group')}}</router-link>
                    <span class="float-left mr-1 main-link">/</span>
                    <router-link :to="{ name: 'menu_group_edit',  params: { id: id }}" class="float-left mr-1 main-link">{{$t('menu_group.recipe_update')}}</router-link>
                    / {{$t('menu_group.common_settings')}}
                  </h3>
                </strong>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('menu_group.common_settings') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateCommonStatus" v-b-toggle.customise_content>
                <i class="fa fa-sort-down" v-if="commonStatus"></i>
                <i class="fa fa-sort-up" v-if="!commonStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="commonStatus" id="customise_content">
              <b-row>
                <b-col cols="12">
                  <b-form class="row" v-if="item != null">
                    <b-col cols="12">
                      <div class="form-group row" v-show="checkShowByConfig('name')">
                        <legend class="col-sm-2 col-form-label">{{$t('menu_group.marketing_name')}}</legend>
                        <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                          <b-form-input type="text"
                                        :name="`name[${lang}]`"
                                        class="form-control border-radius-4px"
                                        v-model="item.name[lang]"
                                        v-bind:placeholder="$t('common.text_' + lang)"
                                        :disabled="checkDisableByConfig('name')"
                          />
                        </div>
                      </div>

                      <div class="form-group row" v-show="checkShowByConfig('marketing_description')">
                        <legend class="col-sm-2 col-form-label">{{$t('menu_group.marketing_description')}}</legend>
                        <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                          <b-form-textarea class="form-control border-radius-4px" v-model="item.marketing_description[lang]" :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('marketing_description')">
                          </b-form-textarea>
                        </div>
                      </div>

                      <div class="form-group row" v-show="checkShowByConfig('main_description')">
                        <legend class="col-sm-2 col-form-label">{{$t('menu_group.main_description')}}</legend>
                        <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                          <b-form-textarea class="form-control border-radius-4px" v-model="item.main_description[lang]" :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('main_description')">
                          </b-form-textarea>
                        </div>
                      </div>

                      <div class="form-group row" v-show="checkShowByConfig('t_and_c')">
                        <legend class="col-sm-2 col-form-label">{{$t('menu_group.t_and_c')}}</legend>
                        <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                          <b-form-textarea class="form-control border-radius-4px" v-model="item.t_and_c[lang]" :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('t_and_c')">
                          </b-form-textarea>
                        </div>
                      </div>
                    </b-col>

                    <b-col cols="12" class="row m-0 p-0" v-show="checkShowByConfig('image')">
                      <div class="col-sm-6 row m-0 p-0 pt-3" v-for="(data, image, index) in imageData" :key="data.id">
                        <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                          {{$t('menu_group.'+image)}}
                          <!-- <i class="fa fa-info-circle text-primary" :id="'image-' + image"></i> -->
                          <b-tooltip :target="'image-' + image" placement="top">
                            <div class="text-left" v-html="getImageHelpInfo('menu_group', image)"></div>
                          </b-tooltip>
                        </legend>
                        <div class="col-sm-8 ">
                          <b-form-file :id="image" @change="previewImage" accept="image/*" :placeholder="$t('message.choose_a_file')"></b-form-file>
                        </div>
                        <div v-bind:class="'image-' + image + '-preview img-min-height'" class="col-sm-8 offset-sm-4">
                          <img class="preview-image" v-bind:src="data">
                        </div>
                      </div>
                    </b-col>
                  </b-form>
                </b-col>
              </b-row>
            </b-collapse>
            <div slot="footer">
              <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="btn-save">
                <button v-if="id !== 'create'" type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="readyPublish(item.uuid)" :disabled="checkDisable"> {{$t('menu_group.apply_common_settings')}}</button>
              </div>
            </div>
          </b-card>
          
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import vSelect from 'vue-select'
import Tables from '../../tables/Tables'
import Multiselect from 'vue-multiselect'

let vm = null

export default {
  name: 'MenuGroupForm',
  props: {
    id: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    Tables,
    cSwitch,
    vSelect,
    Multiselect
  },
  data: function () {
    return {
      single: this.$store.getters.config.gms.menu,
      images: ["desktop_thumbnail", "desktop_detail", "mobile_thumbnail", "mobile_detail"],
      item: {
        uuid: "",
        name: {},
        group_name: {},
        marketing_description: {},
        main_description: {},
        t_and_c: {},
        image: {},
        active: 1,
        menus: []
      },
      imageData: {},
      basicInformationStatus: true,
      commonStatus: true,
      processing: false,
      menuDealList: {},
      menuDealListUpdated: [],
      menuDealListSelected: "",
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {

  },
  computed: {
    checkSubmit: function() {
      return false
    },
    checkDisable: function() {
      let result = false
      let langs = vm.$store.getters.languages

      //Check data
      for (let l in langs) {
        if (!result && vm.item.name[langs[l]] && vm.item.name[langs[l]] !== '') {
          result = true
        }

        if (!result && vm.item.marketing_description[langs[l]] && vm.item.marketing_description[langs[l]] !== '') {
          result = true
        }

        if (!result && vm.item.main_description[langs[l]] && vm.item.main_description[langs[l]] !== '') {
          result = true
        }

        if (!result && vm.item.t_and_c[langs[l]] && vm.item.t_and_c[langs[l]] !== '') {
          result = true
        }
      }

      //Check images
      if (!result) {
        for (let i in vm.images) {
          if (!result && vm.imageData[vm.images[i]] !== '') {
            result = true
          }
        }
      }

      return !result
    }
  },
  methods: {
    checkShowByConfig (key) {
      let config = this._.find(this.single.basic_info, function (o) {
        return o.type === key
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    checkDisableByConfig (key) {
      if (this.single == null) {
        return false
      }
      let config = this._.find(this.single.basic_info, {type: key})
      if (config == null) {
        return false
      }
      return config.disable
    },
    /**
     * update status of customise session
     */
    updateCommonStatus () {
      this.commonStatus = this.commonStatus?false:true
    },
    /**
     * update status of customise session
     */
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    /**
     * preview image after select
     * @param event
     */
    previewImage (event) {
      let input = event.target

      if (input.files && input.files[0]) {
        let reader = new FileReader()

        reader.onload = (e) => {
          this.imageData[input.id] = e.target.result
        }
        // this.imageData = []
        let data = {}
        for (let i in this.images) {
          data[this.images[i]] = this.imageData[this.images[i]]
        }
        this.imageData = data
        reader.readAsDataURL(input.files[0])
        this.item.image[input.id] = input.files[0]
      }
    },
    readyPublish (uuid) {
      // Trigger a confirmation dialog
      let options = {
        okText: vm.$t('common.yes'),
        cancelText: vm.$t('common.no'),
      }
      vm.$dialog.confirm(vm.$t('menu_group.recipe_confirm'), options)
      .then(function (dialog) {
        // Save data
        var item = JSON.parse(JSON.stringify(vm.item))
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        vm.axios.menu.uploadImages(formData, config, function (response) {
          item.image = {}
          for (let i in response.data.data) {
            item.image[i] = response.data.data[i]
          }
          // get old url
          for (let i in oldUrl) {
            item.image[i] = oldUrl[i]
          }
          vm.imageData = item.image

          // check create or update
          vm.axios.updateMenuGroup(item, function (response) {
            // Publish
            vm.axios.menu.publishMenuGroup(uuid, function (response) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.$router.push({name: 'menu_group_list'})
            })
          }, function () {
          })
        })
      })
      .catch(function () {
      });
    },
    getMenuGroupDetail () {
      vm.axios.menu.getMenuGroupDetail(vm.id,
        function (response) {
          let item = response.data.data.item
          vm.item = item
          let langs = vm.$store.getters.languages
          if (vm.item.main_description.length == 0 || Object.getPrototypeOf(Object(vm.item.main_description)) === Object.getPrototypeOf([])) {
            vm.item.main_description = {}
          }
          if (vm.item.t_and_c.length == 0 || Object.getPrototypeOf(Object(vm.item.t_and_c)) === Object.getPrototypeOf([])) {
            vm.item.t_and_c = {}
          }
          if (vm.item.marketing_description.length == 0 || Object.getPrototypeOf(Object(vm.item.marketing_description)) === Object.getPrototypeOf([])) {
            vm.item.marketing_description = {}
          }
          if (vm.item.group_name.length == 0 || Object.getPrototypeOf(Object(vm.item.group_name)) === Object.getPrototypeOf([])) {
            vm.item.group_name = {}
          }
          if (vm.item.name.length == 0 || Object.getPrototypeOf(Object(vm.item.name)) === Object.getPrototypeOf([])) {
            vm.item.name = {}
          }

          for (let i in vm.images) {
            vm.imageData[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
          }
      })
    }
  },
  created: function () {
    vm = this
    vm.getMenuGroupDetail()
  },
  mounted: function () {
    if (vm.id == 'create' || vm.id == undefined) {
      let data = {}
      for (let i in vm.images) {
        data[vm.images[i]] = ""
      }
      vm.imageData = data
    }
  }
}
</script>

<style scoped>
  .menu-group-form .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-group-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-group-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-group-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-group-form .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-group-form .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }
</style>

<style>
  .dg-content-cont--floating
  {
    top: 50% !important;
  }

  .dg-btn--cancel{
    background-color: #0091ff !important;
  }

  .menu-group-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-group-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .preview-image {
    width: 100%;
  }
  .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }
  .points i {
    position: absolute;
  }
  .step-commit {
    margin-left: calc(0% - 10px);
  }
  .step-updated {
    margin-left: calc(33% - 15px);
  }
  .step-publishing {
    margin-left: calc(66% - 15px);
  }
  .step-publish {
    margin-left: calc(100% - 20px);
  }
  .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .current-point {
    font-size: 30px;
  }
  .img-min-height {
    min-height: 161px;
  }
  .custom-checkbox {
    padding-left: 0px;
  }
  .min-width-200{
    min-width: 200px;
  }
  .menu-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/menu-group/BaseSettingForm.vue